import React, { createContext, useContext, useEffect } from 'react';
import useToast from '../hooks/useToast';
import ToastContainer from '../components/ui/ToastContainer';
import { setToastContext } from '../utils/toast';

const ToastContext = createContext();

export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToastContext must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const { toasts, success, error, warning, info, removeToast } = useToast();
  
  const contextValue = { success, error, warning, info };

  useEffect(() => {
    // Set global toast context for compatibility
    setToastContext(contextValue);
  }, [contextValue]);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <ToastContainer toasts={toasts} onRemoveToast={removeToast} />
    </ToastContext.Provider>
  );
};